import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import s from "../BaseIcon.mjs";
const t = (r) => /* @__PURE__ */ o.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Alert",
  ...r,
  children: /* @__PURE__ */ o.jsx("g", {
    children: /* @__PURE__ */ o.jsx("path", {
      d: "M22.54,18.87C21.49,17.05,14.3,4.4,13.5,3.03c-0.79-1.37-2.26-1.37-3.04,0C9.67,4.4,2.44,17.07,1.45,18.87 C0.45,20.67,1.25,22,2.55,22c1.3,0,18.21,0,18.89,0C22.67,22,23.59,20.68,22.54,18.87z M13,18.99h-2v-2h2V18.99z M13,15.01h-2v-8h2 V15.01z"
    })
  })
}), a = (r) => /* @__PURE__ */ o.jsx(s, {
  IconSvg: t,
  ...r
});
export {
  a as default
};
